import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import '../App.scss';

const contactHighlights = [
  { label: 'Sähköposti', value: 'takanenphotography@gmail.com' },
  { label: 'WhatsApp', value: '+358 40 708 2294' },
  { label: 'Saatavuus', value: 'Ma–Pe 08:00–20:00' },
  { label: 'Y-tunnus', value: '13467743-1' },
];

const Contact = () => {
  const form = useRef();
  const [message, setMessage] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    const email = form.current.user_email.value;
    const sentEmails = JSON.parse(localStorage.getItem('sentEmails')) || {};

    if (sentEmails[email] && sentEmails[email] >= 2) {
      setMessage('Hups, olemme jo lähettäneet sinulle kaksi viestiä.');
      return;
    }

    if (window.location.hostname === 'localhost') {
      handleSuccess(email, sentEmails);
    } else {
      emailjs.sendForm('service_lxqtp95', 'template_4310luv', form.current, 'c84N-MTKDQvgRIliN')
        .then((result) => {
          console.log(result.text);
          handleSuccess(email, sentEmails);
        }, (error) => {
          console.log(error.text);
          setMessage('Hups, jotain meni pieleen. Yritä uudelleen.');
        });
    }
  };

  const handleSuccess = (email, sentEmails) => {
    sentEmails[email] = sentEmails[email] ? sentEmails[email] + 1 : 1;
    localStorage.setItem('sentEmails', JSON.stringify(sentEmails));
    setMessage('Kiitos yhteydenotosta! Olemme vastaanottaneet viestisi.');
    setFormSubmitted(true);
  };

  return (
    <section className="contact page-section">
      <span className="section-label">Yhteys</span>
      <h1 className="section-heading">Suunnitellaan projekti yhdessä</h1>
      <p className="section-subtitle">
        Kerro toiveesi ja aikataulusi – vastaan saman päivän aikana ja lähetän ehdotuksen, joka sisältää konseptin, työvaiheet ja selkeän budjetin.
      </p>

      <div className="contact-grid">
        {contactHighlights.map((item) => (
          <article key={item.label} className="contact-card glass-panel">
            <h3>{item.label}</h3>
            <p>{item.value}</p>
          </article>
        ))}
      </div>

      {formSubmitted ? (
        <p className="contact-message">{message}</p>
      ) : (
        <form ref={form} onSubmit={sendEmail} className="contact-form glass-panel">
          <label htmlFor="contact-name">Nimi</label>
          <input id="contact-name" type="text" name="user_name" required placeholder="Yritys tai oma nimesi" />
          <label htmlFor="contact-email">Sähköposti</label>
          <input id="contact-email" type="email" name="user_email" required placeholder="sinä@yritys.fi" />
          <label htmlFor="contact-message">Viesti</label>
          <textarea id="contact-message" name="message" required placeholder="Kerro mitä tarvitset – esim. henkilöstökuvat tai tapahtumadokumentointi." />
          <input type="submit" value="Lähetä" />
        </form>
      )}
      {message && !formSubmitted && <p className="contact-message">{message}</p>}
    </section>
  );
};

export default Contact;
